<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Itinerari-esperienze/01_Pollino/01_6_Gusto/04e_Gusto-prodotti-Pollino.jpg">
<div class="content">
    <h1>Pollino</h1>
    <h3>Percorsi di gusto</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a>Parco Nazionale del Pollino</a> > <a class="active">Percorsi di gusto</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div class="row schedaItinerario">
    <h2>Moscato e non solo tra Pollino e Valle dell’Esaro</h2>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <img class="itinerario-foto" src="../../../assets/images/Itinerari-esperienze/01_Pollino/01_6_Gusto/04e_Gusto-prodotti-Pollino.jpg">
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div id="map" class="mapInfo"></div>
    </div>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <p class="testoItinerario">
            Il percorso di degustazione parte da Castrovillari, in un territorio dove le radici della viticoltura affondano al tempo degli Enotri, 
            all’ XI secolo a.C. Qui troviamo numerose cantine che producono e fanno degustare vini da uve magliocco (DOP Terre di Cosenza Pollino), 
            ma anche Greco Bianco IGP, CALABRIA Bianco, Aglianico rosato, ecc... 
            Fra le Cantine più interessanti si segnala quella di Tenute Ferrocinto che produce anche vini biologici nella splendida masseria fortificata dai Baroni Salituri nel 1849.
            Da Castrovillari si riparte in direzione di Saracena. Si pensi che già nel Cinquecento i barili di Moscato che si producevano qui venivano imbarcati a 
            Scalea per essere consegnati alla corte dei Papi. Questo prezioso nettare, 
            che conquistò lo scrittore britannico Norman Douglas durante il suo viaggio in Calabria all’inizio del Novecento, è Presidio Slow Food. 
            Si produce con uve di vitigni autoctoni, guarnaccia, malvasia, duraca e moscatello, ha un color ambra lucente e profumi e sentori intensissimi di fichi secchi, 
            frutta esotica, mandorle, datteri e miele: insomma, il Mediterraneo in un bicchiere, assolutamente imperdibile. 
            Presso la Cantina Viola è possibile degustare ed acquistare i vini. Imperdibile a Saracena una passeggiata nel “Giardino delle meraviglie”, 
            un luogo terapeutico in cui ritrovare serenità e pace interiore a stretto contatto con la natura, un progetto di agricoltura sociale, 
            integrazione e inclusione, davvero interessante.
            Da Saracena si riparte in direzione sud e si fa sosta ad Altomonte, paese che gode di una posizione formidabile con vista sulla Piana di Sibari, 
            il mar Jonio e la corona dei monti che culminano con la cima di Cozzo del Pellegrino. Il paese, 
            che già Plinio il Vecchio citava tra quelli che producevano vini pregiati, 
            ha mantenuto viva questa tradizione e oggi presenta una realtà attiva di aziende che realizzano liquori e distillati, 
            con essenze del territorio, come la “Liquori Moliterno” dove è possibile degustare e visitare il museo storico aziendale. 
            <br>
            <br>
            Lasciata Altomonte si prosegue verso la valle dell’Esaro. Sulle sponde del bacino lacustre si trova il Parco archeologico con Villa Romana di Larderia, 
            uno dei complessi residenziali extra-urbani di epoca romana più importanti della Calabria, 
            in un contesto paesaggistico davvero suggestivo. Si prosegue verso Mottafollone e da qui verso Roggiano Gravina attraversando i 
            campi coltivati della Valle dell’Esaro. È una zona molto fertile contrassegnata da uliveti e vigneti, 
            con diverse cantine storiche dove è possibile sia soggiornare che degustare gli ottimi vini biologici prodotti da uve Magliocco, 
            ma anche da altri celebri vitigni italiani coltivati in condizioni climatiche speciali, in un territorio ricco di risorse naturali, 
            prima fra tutte l’acqua che sgorga copiosa dalle montagne circostanti. Fermandosi alle Cantine Pacelli è possibile degustare lo spumante a 
            cui è stato assegnato il primo premio al Concours Mondial di Bruxelles nel 2022 e altri ottimi vini oltre a poter anche soggiornare 
            nell’azienda agricola a gestione familiare, quasi tutta al femminile.
        </p>
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div class="row">
            <div class="col">
                <h5>Percorso:</h5>
            </div>
            <div class="col right">
                <h5> in bici</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Difficoltà:</h5>
            </div>
            <div class="col right">
                <h5>intermedia</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Lunghezza:</h5>
            </div>
            <div class="col right">
                <h5>53 Km</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Giorni:</h5>
            </div>
            <div class="col right">
                <h5>2</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Salita:</h5>
            </div>
            <div class="col right">
                <h5>1090 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Discesa:</h5>
            </div>
            <div class="col right">
                <h5>1290 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di Partenza:</h5>
            </div>
            <div class="col right">
                <h5>Castrovillari</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di arrivo:</h5>
            </div>
            <div class="col right">
                <h5>Roggiano Gravina</h5>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</div>
<br>
<br>
<div class="divider2">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-7 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco Nazionale del Pollino.</p>
    </div>
    <div class="col-1 col-xl-1">
        <img src="../../../assets/images/04_Pollino/logo-pollino.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sui sentieri dei<br />"Patriarchi"</h1>
                        <a (click)="goToPatriarchi()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Lungo le strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goTo()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Alle origini<br />dell'avventura<br />umana</h1>
                        <a (click)="goToAvventuraUmana()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-12 col-xl-3 four" id="four">
            <div class="card four">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Viaggio nella<br />cultura<br />arberëshe</h1>
                        <a (click)="goToCulturaArbereshe()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 five" id="five">
            <div class="card five">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Cammini di<br />spiritualità e<br />natura</h1>
                        <a (click)="goToSpiritualitaENatura()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 six" id="six">
            <div class="card six">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Percorsi<br />di gusto</h1>
                        <a (click)="goToPercorsiDiGusto()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider2">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>
